import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import { NoteTooltip } from "APP_ROOT/modules/shared/components";
import api from "APP_ROOT/api";

const RequiredComponentTooltip = ({ lineItem }) => {
  const [requiredComponents, setRequiredComponents] = useState([]);

  useEffect(
    () => {
      if (lineItem) {
        api.repairOrders.lineItems.requiredComponents
          .search(lineItem.id, { reverse: false })
          .then(({ data }) => {
            setRequiredComponents(data.results);
          });
      }

      return function cleanup() {};
    },
    [lineItem && lineItem.id]
  );
  if (!lineItem) return null;
  if (Number(lineItem.required_component_quotes_count) === 0) return null;

  const hasValidPartNumber = requiredComponents.some(
    component =>
      component.part &&
      component.part.part_number &&
      !isEmpty(component.part.part_number)
  );

  if (!hasValidPartNumber) return null;

  const partNumbersString = `PN:<br>${requiredComponents
    .sort((a, b) => b.part.part_number.localeCompare(a.part.part_number))
    .map(component => component.part.part_number)
    .join("<br>")}`;

  return <NoteTooltip note={partNumbersString} color="rgba(255, 0, 0, 1)" />;
};

RequiredComponentTooltip.propTypes = {
  lineItem: PropTypes.shape({})
};

export default RequiredComponentTooltip;



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/RequiredComponentTooltip.jsx